module.exports = __webpack_public_path__ + "assets/img/nav-item-4-19ea0304.png";